<template>
  <ListPayment v-if="showListPayments" />
  <ListEmpty v-else-if="showNoPayments" />
</template>

<script>
import ListPayment from "@/components/payment/ListPayment.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import ListEmpty from "@/components/payment/ListEmpty.vue";

export default {
  components: {
    ListEmpty,
    ListPayment,
  },

  computed: {
    ...mapGetters("profile", ["canSeeBilling"]),
    ...mapState("billing", ["paymentsLoaded", "haveNoPayments"]),
    showListPayments() {
      return this.canSeeBilling && this.paymentsLoaded && !this.haveNoPayments;
    },
    showNoPayments() {
      return this.canSeeBilling && this.paymentsLoaded && this.haveNoPayments;
    },
  },
  methods: {
    ...mapActions("billing", ["getPayments", "getBalance"]),
    ...mapMutations("billing", ["setHaveNoPayments"]),
  },
  async mounted() {
    if (this.canSeeBilling) {
      this.getBalance();
      const res = await this.getPayments();
      this.setHaveNoPayments(!(res.list && res.list.length > 0));
    }
  },
};
</script>

